import { useTranslation } from 'react-i18next';
import { regExpMail, regExpName } from '@global/components/ActiveForm/regexp';
import * as yup from 'yup';
import { getLocaleConfig } from '@global/localization/services';

export const shippingInformationSchema = ({ enableEmail }) => {
  const { t } = useTranslation('', {
    keyPrefix: 'activeForm.validationErr.shipping',
  });

  return yup.object({
    firstName: yup
      .string()
      .matches(regExpName, t('firstNameFormat'))
      .trim(t('firstNameFormat'))
      .required(t('firstName')),
    lastName: yup
      .string()
      .matches(regExpName, t('lastNameFormat'))
      .trim(t('lastNameFormat'))
      .required(t('lastName')),
    phone: yup
      .string()
      .max(15, t('max15PhoneLength'))
      .min(1, t('phoneNumber'))
      .required(t('phoneNumber')),
    address1: yup
      .string()
      .max(30, t('max30AddressLength'))
      .min(4, t('addressLength'))
      .trim(t('addressLength'))
      .required(t('address')),
    address2: yup
      .string()
      .max(30, t('max30AddressLength'))
      .notRequired()
      .min(4, t('addressLength'))
      .nullable()
      .transform((value) => (!!value ? value : null)),
    state: yup.string().when('country', (country) => {
      const stateSchema = yup.string();
      const { stateDropdown, stateDropdownLabel } = getLocaleConfig(country);
      const requireError = `${t('stateReq')} ${stateDropdownLabel}`;
      return stateDropdown ? stateSchema.required(requireError) : stateSchema;
    }),
    city: yup
      .string()
      .max(24, t('max24CityLength'))
      .trim(t('city'))
      .required(t('city')),
    zip: yup
      .string()
      .max(10, t('max10ZipLength'))
      .trim(t('postalCode'))
      .required(t('postalCode')),
    country: yup.string().required(t('country')),
    email: yup.string().when('enableEmail', {
      is: () => enableEmail,
      then: yup
        .string()
        .trim()
        .required(t('emailReq'))
        .matches(regExpMail, t('email'))
        .test('empty-check', t('emailReq'), (value) => value !== ''),
      otherwise: yup.string().notRequired(),
    }),
  });
};
